import { Jumbotron, Container } from 'react-bootstrap'
import errorImage from './../img/payment_error.svg'

const BrusselInfoA = () => {
  return (
    <Container>
      <Jumbotron className='text-center'>
        <img className='mb-4' src={errorImage} alt='error' />
        <p>Error: Belangrijke boodschap voor de mandatarissen met hoofdinschrijving bij Balie Brussel: Sinds 01/01/2025 is het niet langer mogelijk om mandaten toegekend vanaf 01/01/2025 via dit platform te verzekeren.</p>
        <p>Voor vragen kan u contact opnemen per mail via het adres <a href="mailto:spccb@vanbreda.be">spccb@vanbreda.be</a>.</p>
      </Jumbotron>
    </Container>
  )
}

export default BrusselInfoA
